// vitest からは Nuxt auto-import が効かないため明示 import に。
import { readonly, ref, watchEffect, type Ref } from 'vue'
import { storage } from '~/utils/session-storage'
import { getStoreDetail } from './api/store'
import type { GetStore200 } from '~/types/api/Store'
import type { CamelCaseKeys } from '~/types/util'

export type Store = CamelCaseKeys<GetStore200>

const store: Ref<Store> = ref(storage<Store>('store').getItem())
watchEffect(() => storage<Store>('store').setItem(store.value))

const get = async (idAlias: string) => {
  store.value = await getStoreDetail(idAlias)
  return readonly(store) as Ref<Store>
}

export const useStore = () => {
  return {
    store,
    get,
  }
}
